"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var ActionComponent_1 = __importDefault(require("./ActionComponent"));
var AddComponent_1 = __importDefault(require("./AddComponent"));
var info_1 = __importDefault(require("./info"));
function Twins(props) {
  var maxLength = props.maxLength,
    minLength = props.minLength,
    itemClassName = props.itemClassName,
    buttonClassName = props.buttonClassName,
    _a = props.buttonProps,
    buttonProps = _a === void 0 ? {} : _a,
    addButtonClassName = props.addButtonClassName,
    _b = props.addButtonSuffix,
    addButtonSuffix = _b === void 0 ? '组' : _b,
    _c = props.addButtonPrefix,
    addButtonPrefix = _c === void 0 ? '还可以添加' : _c,
    _d = props.addButtonProps,
    addButtonProps = _d === void 0 ? {} : _d,
    _e = props.showLength,
    showLength = _e === void 0 ? true : _e,
    onAdd = props.onAdd,
    _onDelete = props.onDelete,
    _f = props.data,
    data = _f === void 0 ? [] : _f,
    _onChange = props.onChange,
    ItemComponent = props.ItemComponent,
    // eslint-disable-line
    _g = props.ItemActionComponent,
    // eslint-disable-line
    ItemActionComponent = _g === void 0 ? ActionComponent_1["default"] : _g,
    // eslint-disable-line
    _h = props.AddComponent,
    // eslint-disable-line
    AddComponent = _h === void 0 ? AddComponent_1["default"] : _h,
    // eslint-disable-line
    _j = props.addButton,
    // eslint-disable-line
    addButton = _j === void 0 ? true : _j,
    hottag = props.hottag,
    _k = props.ItemProps,
    ItemProps = _k === void 0 ? {} : _k;
  var len = data.length;
  return react_1["default"].createElement("div", __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('odc-twins', {
      'has-delete': len > 1
    }),
    supportAllEvents: true
  }, Twins)), data.map(function (item, i) {
    return react_1["default"].createElement(ItemComponent, {
      data: item,
      key: item.id || i,
      index: i,
      onChange: function onChange(v) {
        return _onChange(v, i);
      },
      itemClassName: itemClassName,
      hottag: hottag,
      onDelete: function onDelete() {
        return _onDelete(i);
      },
      showAction: len > minLength,
      action: react_1["default"].createElement(ItemActionComponent, {
        index: i,
        hottag: hottag,
        className: buttonClassName,
        onDelete: function onDelete() {
          return _onDelete(i);
        },
        buttonProps: buttonProps
      }),
      ItemProps: ItemProps
    });
  }), react_1["default"].createElement(AddComponent, {
    hottag: hottag,
    onAdd: onAdd,
    addButton: addButton,
    addButtonClassName: addButtonClassName,
    addButtonProps: addButtonProps,
    addButtonPrefix: addButtonPrefix,
    addButtonSuffix: addButtonSuffix,
    showLength: showLength,
    maxLength: maxLength,
    minLength: minLength,
    data: data
  }));
}
(0, spaui_utils_1.setComponentMark)(Twins, info_1["default"]);
exports["default"] = react_1["default"].memo(Twins);